<template>

    <div class="row">

        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'cajas-online'}">{{$t("cajaOnline")}}</router-link>
                    </li>
                    <!--<li class="breadcrumb-item">-->
                    <!--<router-link :to="{name:'online-detail', params:{idBusiness: idBusiness}}">-->
                    <!--{{onlineDetails.nameBusiness}}-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <li class="breadcrumb-item active" aria-current="page">
                        <template v-if="config">{{$t("planoDeTaquillas")}}</template>
                        <template v-else>{{$t("planoDeMesas")}}</template>
                    </li>
                </ol>
            </nav>
        </div>


        <div class="col-md-6">
            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead class="thead-dark">
                    <tr>
                        <th>{{$t("nombrePlano")}}</th>
                        <th>
                            <template v-if="config">{{$t("taquillas")}}</template>
                            <template v-else>{{$t("mesas")}}</template>
                        </th>
                        <th>{{$t("ocupacion")}}</th>
                        <th>{{$t("enPlano")}}</th>
                        <th>{{$t("total")}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="m in listMesas">
                        <td>{{m.plano}}</td>
                        <td>{{m.abiertas}} / {{m.total}}</td>
                        <td align="right"><span v-if="m.total>0">{{parseFloat(Math.round((m.abiertas / m.total*100)*100)/100).toFixed(2)}} %</span><span
                                v-else>0.00 %</span></td>
                        <td align="right">{{m.numPosits}}</td>
                        <td align="right">{{m.amount + m.totalPosits | currency}}</td>
                    </tr>
                    <tr class="table-success">
                        <td><strong>{{$t("total")}}:</strong></td>
                        <td><strong>{{getMesasTotal}} / {{numMesas}}</strong></td>
                        <td align="right"><strong>{{Math.round(getOcupacionTotal*100)/100}} %</strong></td>
                        <td align="right"><strong>{{getNumPosits}}</strong></td>
                        <td align="right"><strong>{{getAmountTotal | currency}}</strong></td>
                    </tr>
                    </tbody>
                    <tfoot>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="col-md-6">
            <canvas id="charte"></canvas>
        </div>
        <div class="col-md-12">
            <div class="btn-group" role="group">
                <button v-if="config" type="button" class="btn btn-dark"
                        @click="listPlano=[],idPlano=0,getMesas()"
                        :class="{'active': idPlano == 0}">
                    {{$t("todos")}}
                </button>
                <button @click="listPlano=[],idPlano=m.id,getMesas()" type="button" class="btn btn-dark"
                        :class="{'active': idPlano == m.id}"
                        v-for="m in listSalones">{{m.name}}
                </button>
                <button v-if="!config" type="button" class="btn btn-dark"
                        @click="listPlano=[],idPlano=0,getMesas()"
                        :class="{'active': idPlano == 0}">
                    {{$t("clientes")}}
                </button>

            </div>
        </div>

        <template v-if="config">

            <div class="col-md-12 wrapperPlano">
                <div class="row">
                    <div class="text-center col-md-1 taquilla" v-for="xObj in listPlano">
                        <div class="row">

                            <!--TAQUILLA OCUPADA-->
                            <template v-if="xObj.id!=0">
                                <div class="col-md-12"
                                     @click="getDetailsMesa(xObj.idHeader)"
                                     v-bind:style="[!xObj.superaTiempo ? {'background-color':'#8CB970'} : {'background-color':'#EA7871'}]"
                                     style="background-color: #EEE3AB;border: solid 2px black;height: 128px;cursor: pointer;position: relative">
                                    <div class="row">
                                        <div class="col-md-10"
                                             v-bind:style="[xObj.superaTiempo ? {'background-color':'#EEE3AB','color':'black'} : {'background-color':'#EEE3AB','color':'black'}]"
                                             style="border-radius: 8px; margin-left: auto;margin-right: auto; margin-top:6px">
                                            <strong style="font-size: 100%">{{xObj.number}}</strong><br>
                                            <strong style="font-size: 80%">{{xObj.amount
                                                |
                                                currency}}</strong><br>

                                        </div>
                                        <div class="col-md-12" style="bottom: 6px;position: absolute">
                                            <i style="color: white;text-shadow: 1px 1px black;font-size: 100%"
                                               class="fas fa-clock"></i>
                                            <strong style="text-shadow: 1px 1px black;font-size: 100%;color: white">{{xObj.fechaApertura
                                                | diffHour }}</strong>
                                        </div>
                                    </div>
                                </div>

                            </template>
                            <!--TAQUILLA LIBE-->
                            <template v-else>
                                <div class="col-md-12"
                                     style="background-color: #84A5CB;border: solid 2px black;height: 128px;">
                                    <div class="row">
                                        <div class="col-md-10" style="background-color: #EEE3AB;margin-top: 6px;margin-left:auto;margin-right:auto;border-radius: 4px;">
                                            <strong style="font-size: 100%">{{xObj.number}}</strong><br>
                                        </div>
                                    </div>
                                </div>
                            </template>

                        </div>
                    </div>
                </div>
            </div>

        </template>
        <template v-else>

            <div v-if="idPlano!==0" class="col-md-12">
                <div :style="{height: getHeightPlano()+'px'}" class="wrapperPlano" ref="wrapperPlano">
                    <template v-for="p in listPlano">
                        <template v-if="p.object===0">
                            <template v-if="p.ocupada===1">
                                                <span @click="getDetailsMesa(p.idHeader)" style="cursor: pointer">
                                                <img class="imgPrueba"
                                                     src="../../../../static/img/mesas/mesa_ocupada.png"
                                                     v-bind:style="{top: p.ycoord*diffMapa + 'px', left: p.xcoord*diffMapa+5+ 'px',width: object0Width + 'px'}"/>
                                                <span v-if="p.number>=100" style="position: absolute;color: white"
                                                      v-bind:style="{top: (p.ycoord*diffMapa) + (10*diffMapa) + 'px', left: (p.xcoord*diffMapa+5)+(12*diffMapa) + 'px', fontSize:20*diffMapa+'px'}">{{p.number}}</span>
                                                <span v-else-if="p.number>=10&&p.number<=99"
                                                      style="position: absolute;color: white"
                                                      v-bind:style="{top: (p.ycoord*diffMapa) + (10*diffMapa) + 'px', left: (p.xcoord*diffMapa+3)+(18*diffMapa) + 'px', fontSize:20*diffMapa+'px'}">{{p.number}}</span>
                                                <span v-else style="position: absolute;color: white"
                                                      v-bind:style="{top: (p.ycoord*diffMapa) + (10*diffMapa) + 'px', left: (p.xcoord*diffMapa+5)+(23*diffMapa) + 'px', fontSize:20*diffMapa+'px'}">{{p.number}}</span>
                                                <span style="position: absolute;background-color: white;;border: 1px solid #000"
                                                      v-bind:style="{top: (p.ycoord*diffMapa) + (35*diffMapa) + 'px', left: (p.xcoord*diffMapa)+(diffMapa) + 'px', fontSize:13*diffMapa+'px',paddingLeft:13*diffMapa+'px',paddingRight:13*diffMapa+'px'}">{{p.amount |currency}}</span>
                                            </span>
                            </template>
                            <template v-else>
                                <img class="imgPrueba" src="../../../../static/img/mesas/mesa.png"
                                     v-bind:style="{top: p.ycoord*diffMapa + 'px', left: p.xcoord*diffMapa+5+ 'px',width: object0Width + 'px'}"/>
                                <span v-if="p.number>=100" style="position: absolute;color: white"
                                      v-bind:style="{top: (p.ycoord*diffMapa) + (10*diffMapa) + 'px', left: (p.xcoord*diffMapa+5)+(12*diffMapa) + 'px', fontSize:20*diffMapa+'px'}">{{p.number}}</span>
                                <span v-else-if="p.number>=10&&p.number<=99" style="position: absolute;color: white"
                                      v-bind:style="{top: (p.ycoord*diffMapa) + (10*diffMapa) + 'px', left: (p.xcoord*diffMapa+3)+(18*diffMapa) + 'px', fontSize:20*diffMapa+'px'}">{{p.number}}</span>
                                <span v-else style="position: absolute;color: white"
                                      v-bind:style="{top: (p.ycoord*diffMapa) + (10*diffMapa) + 'px', left: (p.xcoord*diffMapa+5)+(23*diffMapa) + 'px', fontSize:20*diffMapa+'px'}">{{p.number}}</span>
                            </template>
                        </template>
                        <template v-else-if="p.object===1">
                            <template v-if="p.rotate===0 || p.rotate===2">
                                <img class="imgPrueba" src="../../../../static/img/mesas/wall_0.png"
                                     v-bind:style="{top: p.ycoord*diffMapa + 'px', left: p.xcoord*diffMapa+5 + 'px', width:object1Width+'px'}"/>
                            </template>
                            <template v-else>
                                <img class="imgPrueba" src="../../../../static/img/mesas/wall_1.png"
                                     v-bind:style="{top: p.ycoord*diffMapa + 'px', left: p.xcoord*diffMapa+5 + 'px', width:object1Width+'px'}"/>
                            </template>
                        </template>
                        <template v-else-if="p.object===2">
                                            <span style="position: absolute"
                                                  v-bind:style="{top: p.ycoord*diffMapa +(5*diffMapa) + 'px', left: p.xcoord*diffMapa+(diffMapa)+ 'px',fontSize:20*diffMapa+'px', color:p.color}">{{p.name}}</span>

                        </template>
                        <template v-else-if="p.object===5">
                                            <span @click="getDetailsMesa(p.idHeader)" style="cursor: pointer">
                                            <img class="imgPrueba" src="../../../../static/img/mesas/POSTIT.png"
                                                 v-bind:style="{top: p.ycoord-165  + 'px', left: p.xcoord*diffPossitx+5+ 'px',width: object5Width + 'px'}"/>
                                            <span style="position: absolute;"
                                                  v-bind:style="{top: (p.ycoord-165) + (diffMapa) + 'px',
                                                                 left: (p.xcoord*diffPossitx+5)+(diffMapa) + 'px',
                                                                 fontSize:8*diffMapa+'px',
                                                                 paddingLeft:3*diffMapa+'px',
                                                                 paddingRight:3*diffMapa+'px'}"><strong>{{p.name}}</strong></span>

                                            <span style="position: absolute;"
                                                  v-bind:style="{top: (p.ycoord-165) + (20*diffMapa) + 'px', left: (p.xcoord*diffPossitx+15)+(diffMapa) + 'px', fontSize:10*diffMapa+'px',paddingLeft:3*diffMapa+'px',paddingRight:3*diffMapa+'px'}">{{p.amount |currency}}</span>
                                            </span>
                        </template>
                    </template>
                </div>
            </div>
            <div v-else class="col-md-12">

                <div class="row wrapperPlano" :style="{height: getHeightPlano()+'px'}">
                    <div @click="getDetailsMesa(p.idHeader)" class="col-md-1 posits" style="text-align: center;"
                         v-for="p in listPlano">
                        <h4 style="padding-top: 10%">{{p.name}}</h4>

                        <span>{{p.amount | currency}}</span>
                    </div>
                </div>


            </div>
        </template>


        <modal name="modal-detalles-mesa" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("desgloseTicket")}}</h4>
                </div>
                <div class="modal-body">
                    <div class="col-md-12">
                        <template v-for="ticket in tickets">
                            <ticket :ticket="ticket"></ticket>
                        </template>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="cerrarModal()" class="btn btn-default"><i class="fa fa-times-circle"></i>
                        {{$t("cerrar")}}
                    </button>

                </div>
            </div>
        </modal>
    </div>


</template>

<script>
    import Ticket from '../../Widgets/Ticket.vue'
    import {DatePicker, Select, Option, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'

    export default {
        name: "PlanosMesas",

        components: {
            'ticket': Ticket,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [ButtonGroup.name]: ButtonGroup
        },

        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("cajasOnlinePlano"));
            this.getPlanos();


        },
        computed: {
            getAmountTotal() {
                let total = 0;
                this.listMesas.forEach(function (d) {
                    total += d.amount + d.totalPosits;
                });
                return total;
            },
            getMesasTotal() {
                let total = 0;

                this.listMesas.forEach(function (d) {

                    total += d.abiertas;
                });
                return total;
            },
            getNumPosits() {
                let total = 0;

                this.listMesas.forEach(function (d) {

                    total += d.numPosits;
                });
                return total;
            },
            getOcupacionTotal() {
                let total = 0;
                let vm = this;
                this.listMesas.forEach(function (d) {
                    total += Math.round((d.abiertas / vm.numMesas * 100) * 100) / 100;
                });
                return total;
            },

            diffMapa() {

                var widthWrapper = screen.width;
                return widthWrapper / 875;
            },

            diffPossity() {

                var widthWrapper = screen.width;
                return widthWrapper / 4500;
            },

            diffPossitx() {

                var widthWrapper = screen.width;
                return widthWrapper / 2300;
            },

            object5Width() {
                return 50 * this.diffMapa;
            },

            object0Width() {
                return 58 * this.diffMapa;
            },
            object1Width() {
                return 80 * this.diffMapa;
            },


        },
        data() {
            return {

                listMesas: [],
                numMesas: 0,
                idBusiness: this.$route.params.idBusiness,


                idPlano: 0,
                listPlano: [],
                tickets: [],
                listSalones: [],

                config: false,


            }
        },

        methods: {
           
            getPlanos() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "online/getPlanos", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.listMesas = response.data.result.mesas;
                            vm.numMesas = response.data.result.totalMesas;
                            vm.listSalones = response.data.result.salones;

                            if (response.data.result.config) {

                                vm.idPlano = 0;
                                vm.config = response.data.result.config;

                            }else{
                                vm.idPlano=response.data.result.salones[0].id;
                            }

                            vm.initChart(response.data.result.mesas, vm.numMesas);
                            vm.getMesas();
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getDetailsMesa(header) {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idHeader: header,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "online/getDetailsMesa", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.tickets = response.data.result
                            vm.$modal.show("modal-detalles-mesa");
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            },

            cerrarModal() {

                this.$modal.hide("modal-detalles-mesa")
            },

            getMesas() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idPlano: this.idPlano,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "online/getMesas", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.listPlano = response.data.result;

                            for (let i = 0; i < vm.listPlano.length; i++) {

                                if (vm.listPlano[i].amount > 0) {
                                    vm.countDownTimer(vm.listPlano[i]);
                                }
                            }

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            initChart(listMesas, numMesas) {

                var labels = listMesas.map(function (x) {
                    return x.plano;
                });

                var data = listMesas.map(function (x) {
                    return Math.round((x.abiertas / numMesas * 100) * 100) / 100;
                });

                if (this.$chart) {
                    this.$chart.destroy();
                }

                this.$chart = new Chart('charte', {
                    type: 'doughnut',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: ["rgba(70,191,189,1)",
                                "rgba(253,180,92,1)",
                                "rgba(247,70,74,1)"],
                            pointBackgroundColor: "rgba(0,0,0,1)",
                            borderColor: "rgba(0,0,0,0.6)",
                            borderWidth: 1
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: true,
                        }
                    }
                });

            },

            getHeightPlano() {
                var widthWrapper = screen.width;
                var diffMapa = widthWrapper / 649;

                if (400 * diffMapa >= 900) {
                    return 900;
                } else {
                    return 400 * diffMapa;
                }
            },

            countDownTimer(initHora) {
                if (initHora.fechaApertura > 0) {
                    setTimeout(() => {
                        initHora.fechaApertura += 1;
                        this.countDownTimer(initHora)
                    }, 1000)
                }
            }


        }
    }
</script>

<style scoped>

    .wrapperPlano {
        margin-top: 20px;
        background-image: url("https://www.numier.com/online/static/img/mesas/dark_brick_wall.png");
    }

    .numMesa {
        position: absolute;
        color: white;
    }

    .imgPrueba {
        position: absolute;
    }

    .card-body {
        padding: 10px 15px;
    }

    .taquilla {
        margin: 5px;
        z-index: 2;
    }

    .posits {

        background: url("../../../../static/img/mesas/POSTIT.png") no-repeat;
        background-size: 100%;

    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Online/OnlinePlano.vue